/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import {
  injectIntl,
} from 'react-intl';
import CSSModules from 'react-css-modules';
import Select from '../Select';
import styles from './styles/main.scss';


const propTypes = {
  pageSize: React.PropTypes.number.isRequired,
  options: React.PropTypes.array.isRequired,
  onChange: React.PropTypes.func.isRequired,
};

class PageSizer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: props.pageSize,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.pageSize !== nextProps.pageSize) {
      this.setState({
        pageSize: nextProps.pageSize,
      });
    }
  }

  handleChange(v) {
    const { onChange } = this.props;
    const pageSize = Number(v);
    if (onChange) {
      onChange(pageSize);
    }
  }

  render() {
    const { options } = this.props;
    const { pageSize } = this.state;

    return (
      <div styleName="page-sizer">
        <div styleName="page-select">
          <Select
            onChange={this.handleChange}
            value={pageSize}
            options={options.map(opt => ({ value: opt, label: opt }))}
          />
        </div>
      </div>
    );
  }
}

PageSizer.propTypes = propTypes;

export default injectIntl(CSSModules(PageSizer, styles, { allowMultiple: true }));




// WEBPACK FOOTER //
// ./src/components/PageSizer/index.jsx